
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Component} from "vue-property-decorator";
import { AccessRequestType } from "./access.types";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {required} from "vuelidate/lib/validators";

@Component
export default class AccessForm extends Form {

    @Validate(required, i18nText("Введите назавание сервиса"))
    access_data_name: string | null = null;
    name: string | null = null;
    login: string | null = null;
    password: string | null = null;
    link: string | null = null;
    salon_id: number | null = null;

    getFormData(): AccessRequestType {
       return{
            access_data_name: this.access_data_name,
            name: this.name,
            login: this.login,
            password: this.password,
            link: this.link,
            salon_id: this.salon_id,
       } 
    }
}
